import { CSSObject } from '@chakra-ui/react';

export const NoRacesWrapper: CSSObject = {
  color: 'gray.700',
};
